module.exports = __webpack_public_path__ + "img/7_92.a324aa22.png";